module.exports = __webpack_public_path__ + "img/banner.6d30fe4f.png";